export default "__VITE_ASSET__C07bREZj__"